const baseURL = `${process.env.VUE_APP_SERVER_URL}/PrimeiroAcesso`;

export async function TermoAceiteAtual({ device }) {
  return globalThis.window.$axios
    .post({
      url: `${baseURL}/TermoAceiteAtual`,
      query: {
        device,
        versao: 3
      }
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("TermoAceiteAtual", error.message);
      return error;
    });
}

export async function AceitarTermo({ hash }) {
  return globalThis.window.$axios
    .post({
      url: `${baseURL}/AceitarTermo`,
      query: {
        hash
      }
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("AceitarTermo", error.message);
      return error;
    });
}

export async function ValidarIdentificacao({ hash, codigo }) {
  const vinculoEncrypted = globalThis.window.$jse.encrypt(codigo);
  return globalThis.window.$axios
    .post({
      url: `${baseURL}/ValidarIdentificacao`,
      query: {
        hash,
        vinculoEncrypted
      }
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("ValidarIdentificacao", error.message);
      return error;
    });
}

export async function EnviarConfirmacao({ hash, email }) {
  return globalThis.window.$axios
    .post({
      url: `${baseURL}/EnviarConfirmacao`,
      query: {
        hash,
        email
      }
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("EnviarConfirmacao", error.message);
      return error;
    });
}

export async function InformarConfirmacao({ hash, codigo }) {
  return globalThis.window.$axios
    .post({
      url: `${baseURL}/InformarConfirmacao`,
      query: {
        hash,
        codigo
      }
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("InformarConfirmacao", error.message);
      return error;
    });
}

export async function CadastrarEmail({ hash, email }) {
  return globalThis.window.$axios
    .post({
      url: `${baseURL}/CadastrarEmail`,
      query: {
        email,
        hash
      }
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("CadastrarEmail", error.message);
      return error;
    });
}

export async function CadastrarUsuarioOmint({ hash, senha }) {
  const senhaEncrypted = globalThis.window.$jse.encrypt(senha);
  return globalThis.window.$axios
    .post({
      url: `${baseURL}/CadastrarUsuarioOmint`,
      query: {
        hash,
        senhaEncrypted
      }
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("CadastrarUsuarioOmint", error.message);
      return error;
    });
}

export async function CadastrarBiometria({ hash, selfie }) {
  return globalThis.window.$axios
    .post({
      url: `${baseURL}/CadastrarBiometria`,
      query: {
        hash
      },
      data: {
        selfie
      }
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("CadastrarBiometria", error.message);
      return error;
    });
}

export async function VerificarCadastroBiometria({ hash }) {
  return globalThis.window.$axios
    .get({
      url: `${baseURL}/VerificarCadastroBiometria`,
      query: {
        hash
      }
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("VerificarCadastroBiometria", error.message);
      return error;
    });
}

export async function AutenticarBiometria({ hash, selfie }) {
  return globalThis.window.$axios
    .post({
      url: `${baseURL}/AutenticarBiometria`,
      query: {
        hash
      },
      data: {
        selfie
      }
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("AutenticarBiometria", error.message);
      return error;
    });
}

export async function RegistrarErroBiometria({ hash, codigo, descricao }) {
  return globalThis.window.$axios
    .post({
      url: `${baseURL}/RegistrarErroBiometria`,
      query: {
        hash
      },
      data: {
        codigo,
        descricao
      }
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("RegistrarErroBiometria", error.message);
      return error;
    });
}
